import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";
/**
 * Functon type declare
 */
export type FuncAction = (
    dispatch: Dispatch,
    getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    INIT_CASH_LEFT_OVER: {
        LOADING: "INIT_CASH_LEFT_OVER_LOADING",
        SUCCESS: "INIT_CASH_LEFT_OVER_SUCCESS",
        ERROR: "INIT_CASH_LEFT_OVER_ERROR",
    },
    SAVE_CASH_LEFT_OVER: {
        LOADING: "SAVE_CASH_LEFT_OVER_LOADING",
        SUCCESS: "SAVE_CASH_LEFT_OVER_SUCCESS",
        CLEAN: "SAVE_CASH_LEFT_OVER_CLEAN",
        ERROR: "SAVE_CASH_LEFT_OVER_ERROR",
    },
};

/**
 * All store state
 */
export interface CashLeftOverState {
    resultInit: any;
    resultSave: any;
    isLoading?: boolean;
    error?: any;
}

/**
 * Store's action definition
 */
export interface ICashLeftOverAction extends Action {
    payload: any;
    error: any;
}
